import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../@bizkeytech";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class UiComponentsController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the UI components from the server.
     *
     * @param request           The request to fetch the UI components.
     * @param abortController   The abort controller that will be used to cancel the request.
     */
    public async list(request: models.GetApplicationUIComponentsRequest, abortController?: AbortController): models.GetApplicationUIComponentsResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.uiComponent.getData,
            signal: abortController?.signal,
            params: {applicationName: request.applicationName},
            showErrorToast: false,
        });
    }

    /**
     * Saves the UI components to the server.
     *
     * @param request           The request to save the UI components.
     * @param abortController   The abort controller that will be used to cancel the request.
     */
    public async save(request: models.SaveApplicationUIComponentRequest, abortController?: AbortController): models.SaveApplicationUIComponentResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.uiComponent.saveData,
            signal: abortController?.signal,
            data: request,
            showErrorToast: false,
        });
    }
}

export * from "./index.types";
export default UiComponentsController;